import React from "react";

interface DevicePreviewProps {
  emailContent: string;
  deviceMode?: "desktop" | "tablet" | "mobile";
}

const DevicePreview: React.FC<DevicePreviewProps> = ({
  emailContent,
  deviceMode = "desktop"
}) => {
  return (
    <div className="device-preview-container">
      <div className={`preview-frame ${deviceMode}-frame`}>
        <div
          className="preview-content"
          dangerouslySetInnerHTML={{ __html: emailContent }}
        />
      </div>
    </div>
  );
};

export default DevicePreview;
